import { useMemo } from 'react';

function useFilteredUsers(users, searchTerm, filterBy, sortBy, createdAt) {
  const filteredUsers = useMemo(() => {
    let result = [...users];

    // Search filter
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      result = result.filter((user) =>
        user.email?.toLowerCase().includes(searchLower) ||
        user.referralCode?.toLowerCase().includes(searchLower)
      );
    }

    // Date filter
    if (createdAt) {
      result = result.filter((user) => {
        if (!user.createdAt) return false;
        return (
          new Date(user.createdAt.toDate()).toLocaleDateString('en-US') ===
          new Date(createdAt).toLocaleDateString('en-US')
        );
      });
    }

    // Status filter
    switch (filterBy) {
      case 'active':
        result = result.filter((user) => !user.disabled);
        break;
      case 'disabled':
        result = result.filter((user) => user.disabled);
        break;
      case 'referred':
        result = result.filter((user) => user.referrerId);
        break;
      case 'admin':
        result = result.filter((user) => user.role === 'admin');
        break;
      case 'manager':
        result = result.filter((user) => user.role === 'manager');
        break;
      default:
        break;
    }

    // Sorting
    switch (sortBy) {
      case 'newest':
        result.sort(
          (a, b) => b.createdAt?.toDate() - a.createdAt?.toDate()
        );
        break;
      case 'oldest':
        result.sort(
          (a, b) => a.createdAt?.toDate() - b.createdAt?.toDate()
        );
        break;
      case 'credits':
        result.sort(
          (a, b) => (b.credits || 0) - (a.credits || 0)
        );
        break;
      default:
        break;
    }

    return result;
  }, [users, searchTerm, filterBy, sortBy, createdAt]);

  return filteredUsers;
}

export default useFilteredUsers;
